// External libs
import React, { useState, useEffect } from "react";
import axiosInstance from '../../utils/axiosInstance.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark, faTrash } from '@fortawesome/free-solid-svg-icons';

// Assets
import './popupPage.css';

// Components
import { route_get_firmwares, route_delete_firmwares } from '../../constants/BackendRoutes.js';

const FirmwareDeletePopup = ({ onClose, deviceTypes }) => {
    const [selectedDevice, setSelectedDevice] = useState("");
    const [firmwareList, setFirmwareList] = useState([]);
    const [error, setError] = useState("");
    const [progressMsg, setProgressMsg] = useState('');

    useEffect(() => {
        setError("");
        setProgressMsg("");

        if (deviceTypes.length > 0) {
            setSelectedDevice(deviceTypes[0]);
        }
    }, []);

    useEffect(() => {
        if (!selectedDevice) {
            return;
        }
        fetchFirmwareList(selectedDevice);
    }, [selectedDevice]);

    const fetchFirmwareList = async (deviceType) => {
        try {
            const url = `${route_get_firmwares}/${deviceType}`;
            console.log("Fetching firmware list from:", url);
            const response = await axiosInstance.get(url);
            const firmwareList = response.data;

            const updatedFirmwareList = await Promise.all(firmwareList.map(async (fw) => {
                const firmwareMetadataUrl = `${route_get_firmwares}/${deviceType}/${fw.fw_ver}`;  // Assuming this is the endpoint to fetch metadata for each version
    
                try {
                    // Fetch metadata (like crc and fwlength)
                    console.log(firmwareMetadataUrl);
                    const metadataResponse = await axiosInstance.get(firmwareMetadataUrl);
                    const { crc, fwlength } = metadataResponse.data; // Adjust based on the actual structure of the metadata response
                    
                    // Merge the original firmware data with the new metadata
                    return {
                        ...fw, // Original data
                        crc: crc || null,  // Add crc value (default to null if missing)
                        fwlength: fwlength || null // Add file size (fwlength), default to null if missing
                    };
                } catch (err) {
                    if ('status' in err)
                    {
                      console.log(`Backend not responding: ${err.status} error`);
                    }
                    else
                    {
                        console.error(`Error fetching metadata for version ${fw.fw_ver}:`, err);
                    }
                    return { ...fw, crc: null, fwlength: null }; // Return original data with null values for metadata
                }
            }));

            setFirmwareList(updatedFirmwareList);
            setError("");
        } catch (err) {
            if ('status' in err)
            {
              console.log(`Backend not responding: ${err.status} error`);
            }
            else
            {
                console.error(err);
            }
            setError("No Firmware Found for the device.");
            setFirmwareList([]);
        }
    };

    const handleDeleteFirmware = async (firmwareVersion) => {
        const isConfirmed = window.confirm(`Are you sure you want to delete firmware version ${firmwareVersion}?`);
    
        if (!isConfirmed) return; // Exit if the user cancels

        try {
            const url = `${route_delete_firmwares}/${selectedDevice}/${firmwareVersion}`;
            console.log("Deleting firmware:", url);
            await axiosInstance.delete(url);
            setFirmwareList(firmwareList.filter(fw => fw.fw_ver !== firmwareVersion));
        } catch (err) {
            setError("Failed to delete firmware.");
            console.error(err);
        }
        setProgressMsg(`Firmware ${firmwareVersion} deleted.`);
    };

    return (
            <div className="popup-overlay">
                <div className="popup">
                    <div className="popup-header">
                        <span className="popup-title">Manage Firmware</span>
                        <button className="close-btn" onClick={onClose}>
                            <FontAwesomeIcon icon={faXmark} />
                        </button>
                    </div>
    
                    {/* Device Type Selection */}
                    <label className="block text-sm font-medium mb-2">Select Device Type:</label>
                    <select
                        className="popup-select"
                        value={selectedDevice}
                        onChange={(e) => setSelectedDevice(e.target.value)}
                    >
                        {deviceTypes.map((device) => (
                            <option key={device} value={device}>
                                {device}
                            </option>
                        ))}
                    </select>
    
                    {/* Firmware List */}
                    {error && <p className="error">{error}</p>}
                    {progressMsg && (
                        <div>
                            <p className = "success-message">{progressMsg}</p>
                        </div>
                    )}
                    <div className="firwmware-list">
                        <table>
                            <thead>
                                <tr>
                                    <th className="optional-column">Version</th>
                                    <th className="optional-column">CRC</th>
                                    <th className="optional-column">File Size (bytes)</th>
                                    <th></th>
                                </tr>
                            </thead>
                        {firmwareList.length === 0 ? (
                            <td colSpan="4" style={{ textAlign: 'center' }}>No firmware found</td>
                        ) : (

                            <tbody>
                                {firmwareList.map((fw) => (
                                    <tr key={fw.fw_ver}>
                                        <td class="optional-column"><span class="table-text">{fw.fw_ver}</span></td>
                                        <td>
                                            <span class="table-text monospace">
                                                {fw.crc? fw.crc : "N/A"}
                                            </span>
                                        </td>
                                        <td class="optional-column"><span class="table-text">{fw.fwlength ? fw.fwlength : "N/A"}</span></td>
                                        <td><span class="table-text">
                                            <button 
                                                onClick={() => handleDeleteFirmware(fw.fw_ver)}
                                                className="submit-btn">
                                                <FontAwesomeIcon icon={faTrash} />
                                            </button>
                                        </span></td>
                                    </tr>
                                ))}
                            </tbody>
                        )}
                        </table>
                    </div>
    
                    {/* Close Button */}
                    <button className="popup-submit-btn" onClick={onClose}>
                        Close
                    </button>
                </div>
            </div>
    );    
};

export default FirmwareDeletePopup;
